export default {
  metadata: {
    version: '2.0.0',
    id: 'badge-brand-2.0.0',
    name: 'JDSBadgeV2Brand'
  },
  hierarchy: {
    container: [
      {
        'image-container': ['brand-jds_image']
      },
      'label-jds-text'
    ]
  },
  base: {
    container: {
      'flex-direction': '{b_0}',
      'justify-content': '{b_1}',
      'align-items': '{b_2}',
      'background-color': '{b_3}',
      gap: '{b_4}',
      'border-radius': '{b_5}',
      'padding-left': '{b_6}',
      'padding-right': '{b_7}',
      'padding-top': '{b_8}',
      'padding-bottom': '{b_9}'
    },
    'image-container': {
      'border-radius': '{b_10}',
      size: '{b_11}',
      overflow: 'hidden'
    },
    'brand-jds_image': {
      aspectRatio: 'round',
      roundedCorner: false
    },
    'label-jds-text': {
      'font-family': '{text_137}',
      color: '{text_62}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false
    }
  },
  variant: {
    kind: {
      circle: {
        container: {
          'padding-left': '{b_40}',
          'padding-right': '{b_40}',
          'padding-top': '{b_40}',
          'padding-bottom': '{b_40}'
        },
        'label-jds-text': {
          hidden: true
        }
      },
      square: {
        container: {
          'border-radius': '{b_13}',
          'padding-left': '{b_41}',
          'padding-right': '{b_41}',
          'padding-top': '{b_41}',
          'padding-bottom': '{b_41}'
        },
        'image-container': {
          'border-radius': '{b_12}'
        },
        'brand-jds_image': {
          aspectRatio: 'square'
        },
        'label-jds-text': {
          hidden: true
        }
      },
      'square-label': {
        container: {
          'border-radius': '{b_15}'
        },
        'image-container': {
          'border-radius': '{b_16}'
        },
        'brand-jds_image': {
          aspectRatio: 'square'
        }
      }
    },
    size: {
      medium: {
        container: {
          'padding-left': '{b_17}',
          'padding-right': '{b_18}',
          'padding-top': '{b_19}',
          'padding-bottom': '{b_20}'
        },
        'image-container': {
          size: '{b_21}'
        },
        'label-jds-text': {
          'font-family': '{text_172}',
          'font-size': '{text_171}',
          'line-height': '{text_173}',
          'letter-spacing': '{text_174}',
          'font-weight': '{text_175}'
        }
      },
      large: {
        container: {
          'padding-left': '{b_22}',
          'padding-right': '{b_23}',
          'padding-top': '{b_24}',
          'padding-bottom': '{b_25}'
        },
        'image-container': {
          size: '{b_26}'
        },
        'label-jds-text': {
          'font-family': '{text_172}',
          'font-size': '{text_171}',
          'line-height': '{text_173}',
          'letter-spacing': '{text_174}',
          'font-weight': '{text_175}'
        }
      },
      'xtra-large': {
        container: {
          'padding-left': '{b_27}',
          'padding-right': '{b_28}',
          'padding-top': '{b_29}',
          'padding-bottom': '{b_30}'
        },
        'image-container': {
          size: '{b_31}'
        },
        'label-jds-text': {
          'font-family': '{text_152}',
          'font-size': '{text_151}',
          'line-height': '{text_153}',
          'letter-spacing': '{text_154}',
          'font-weight': '{text_155}'
        }
      },
      'xtra-xtra-large': {
        container: {
          'padding-left': '{b_32}',
          'padding-right': '{b_33}',
          'padding-top': '{b_34}',
          'padding-bottom': '{b_35}'
        },
        'image-container': {
          size: '{b_36}'
        },
        'label-jds-text': {
          'font-family': '{text_152}',
          'font-size': '{text_151}',
          'line-height': '{text_153}',
          'letter-spacing': '{text_154}',
          'font-weight': '{text_155}'
        }
      },
      'xtra-xtra-xtra-xtra-large': {
        container: {
          gap: '{b_37}'
        },
        'image-container': {
          size: '{b_38}'
        },
        'label-jds-text': {
          'font-family': '{text_107}',
          'font-size': '{text_106}',
          'line-height': '{text_108}',
          'letter-spacing': '{text_109}',
          'font-weight': '{text_110}'
        }
      }
    },
    emphasis: {
      bold: {
        container: {
          'background-color': '{b_39}'
        }
      }
    }
  },
  combination: [
    {
      circle: {
        medium: {
          container: {
            'padding-left': '{b_42}',
            'padding-right': '{b_42}',
            'padding-top': '{b_42}',
            'padding-bottom': '{b_42}'
          },
          'image-container': {
            size: '{b_43}'
          }
        },
        large: {
          container: {
            'padding-left': '{b_44}',
            'padding-right': '{b_44}',
            'padding-top': '{b_44}',
            'padding-bottom': '{b_44}'
          },
          'image-container': {
            size: '{b_45}'
          }
        },
        'xtra-large': {
          container: {
            'padding-left': '{b_46}',
            'padding-right': '{b_46}',
            'padding-top': '{b_46}',
            'padding-bottom': '{b_46}'
          },
          'image-container': {
            size: '{b_47}'
          }
        },
        'xtra-xtra-large': {
          container: {
            'padding-left': '{b_48}',
            'padding-right': '{b_48}',
            'padding-top': '{b_48}',
            'padding-bottom': '{b_48}'
          },
          'image-container': {
            size: '{b_49}'
          }
        },
        'xtra-xtra-xtra-large': {
          'image-container': {
            size: '{b_51}'
          }
        },
        'xtra-xtra-xtra-xtra-large': {
          'image-container': {
            size: '{b_53}'
          }
        }
      },
      square: {
        medium: {
          container: {
            'border-radius': '{b_54}',
            'padding-left': '{b_55}',
            'padding-right': '{b_55}',
            'padding-top': '{b_55}',
            'padding-bottom': '{b_55}'
          },
          'image-container': {
            size: '{b_56}',
            'border-radius': '{b_57}'
          }
        },
        large: {
          container: {
            'border-radius': '{b_58}',
            'padding-left': '{b_59}',
            'padding-right': '{b_59}',
            'padding-top': '{b_59}',
            'padding-bottom': '{b_59}'
          },
          'image-container': {
            size: '{b_60}',
            'border-radius': '{b_61}'
          }
        },
        'xtra-large': {
          container: {
            'border-radius': '{b_62}',
            'padding-left': '{b_63}',
            'padding-right': '{b_63}',
            'padding-top': '{b_63}',
            'padding-bottom': '{b_63}'
          },
          'image-container': {
            size: '{b_64}',
            'border-radius': '{b_65}'
          }
        },
        'xtra-xtra-large': {
          container: {
            'border-radius': '{b_66}',
            'padding-left': '{b_67}',
            'padding-right': '{b_67}',
            'padding-top': '{b_67}',
            'padding-bottom': '{b_67}'
          },
          'image-container': {
            size: '{b_68}',
            'border-radius': '{b_69}'
          }
        },
        'xtra-xtra-xtra-large': {
          'image-container': {
            size: '{b_70}'
          }
        },
        'xtra-xtra-xtra-xtra-large': {
          'image-container': {
            size: '{b_71}'
          }
        }
      },
      'square-label': {
        medium: {
          container: {
            'border-radius': '{b_73}'
          }
        },
        large: {
          container: {
            'border-radius': '{b_74}',
            'padding-right': '{b_75}'
          }
        },
        'xtra-large': {
          container: {
            'border-radius': '{b_76}',
            'padding-right': '{b_77}'
          }
        },
        'xtra-xtra-large': {
          container: {
            'border-radius': '{b_81}',
            'padding-left': '{b_78}'
          },
          'image-container': {
            size: '{b_79}'
          }
        },
        'xtra-xtra-xtra-large': {
          container: {
            'padding-right': '{b_80}'
          }
        },
        'xtra-xtra-xtra-xtra-large': {
          container: {
            'padding-right': '{b_82}'
          },
          'image-container': {
            'border-radius': '{b_72}'
          }
        }
      }
    }
  ],
  combination_config: [['kind', 'size']],
  api: {
    config: {
      kind: {
        values: ['circle-label', 'circle', 'square', 'square-label']
      },
      size: {
        values: [
          'xtra-xtra-xtra-large',
          'medium',
          'large',
          'xtra-large',
          'xtra-xtra-large',
          'xtra-xtra-xtra-xtra-large'
        ]
      },
      emphasis: {
        values: ['light', 'bold']
      }
    },
    data: {
      'brand-jds_image': {
        src: {
          type: 'image',
          name: 'image'
        }
      },
      'label-jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
